import React, { memo } from "react";
import classnames from "classnames";
import { Element } from "../base";

interface IProps {
    className?: string;
    children: React.ReactNode;
}

function MessageBody(props: IProps) {
    const { className, children, ...rest } = props;
    return (
        <Element className={classnames("message-body", className)} {...rest}>
            {children}
        </Element>
    );
}

export default memo(MessageBody);
